module.exports = __webpack_public_path__ + "static/second_user_image8-07ac08eccd2bc1c81c79c42d18b86618.jpg";